// frontend/src/hooks/useBrowserSession.js
import { useContext } from 'react'
import { BrowserSessionContext } from '../contexts/BrowserSessionContext'

export const useBrowserSession = () => {
  const context = useContext(BrowserSessionContext)
  if (!context) {
    throw new Error('useBrowserSession must be used within a BrowserSessionProvider')
  }
  return context
}

export default useBrowserSession